import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    template: `
        <router-outlet />
        @if (loading()) {
            {{ helloWorldResponse.message }}
        }
    `,
    styles: []
})
export class AppComponent {
    helloWorldResponse = {
        message: 'Hello World!'
    };

    loading = signal(true);

    constructor() {
        console.log(environment.stage);

        setTimeout(() => this.loading.set(false), 300);
    }
}
